var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const Video = (_a) => {
    var { color = "white", size = 38, className } = _a, props = __rest(_a, ["color", "size", "className"]);
    return (React.createElement("svg", Object.assign({ className: className, width: size, height: size, viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.22678 7.11191C9.22678 8.27449 8.43462 9.09583 7.16762 9.09583H3.54103C2.2752 9.09583 1.48828 8.27449 1.48828 7.11191V3.05191C1.48828 1.88991 2.2752 1.06274 3.54745 1.06274H7.16762C8.43462 1.06274 9.22678 1.88991 9.22678 3.05191V7.11191Z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M9.22656 4.57891L11.6165 2.62241C11.9956 2.31033 12.5714 2.58158 12.5714 3.07566V7.08433C12.5714 7.579 11.9956 7.84908 11.6165 7.53758L9.22656 5.58108", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Video.js.map